import { closeSnackbar } from 'notistack';
import React, { useEffect, useRef, useState } from 'react';
import { hapticsImpactLight } from '../../../../utils/haptics';
import StopIcon from '../../../../assets/images/standard/stop.svg';
import { Pause } from 'react-feather';
import { StudyPhase } from '../../../../slices/study/studySlice';

interface PopoverPauseEndMenuProps {
  isFooter: boolean;
  allQuestionsSubmitted: boolean;
  studyPhase: StudyPhase;
  isDemo: boolean;
  isSubmitted: boolean;
  pauseBlock: () => void;
  setConfirmEndIsOpen: (isOpen: boolean) => void;
}

const PopoverPauseEndMenu: React.FC<PopoverPauseEndMenuProps> = ({
  isFooter,
  allQuestionsSubmitted,
  studyPhase,
  isDemo,
  isSubmitted,
  pauseBlock,
  setConfirmEndIsOpen,
}) => {
  // State for controlling tooltip visibility
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const tooltipRef = useRef<HTMLDivElement>(null);

  // Handle click outside to close tooltip
  useEffect(() => {
    const handleClickOutside = (event: Event) => {
      if (
        tooltipRef.current &&
        !tooltipRef.current.contains(event.target as Node)
      ) {
        setTooltipOpen(false);
      }
    };

    if (tooltipOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('touchstart', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [tooltipOpen]);

  return (
    <div className="pause-submit-container" style={{ position: 'relative' }}>
      <button
        className="button button--exam-glass"
        onClick={() => {
          hapticsImpactLight();
          closeSnackbar();
          setTooltipOpen(!tooltipOpen);
        }}
      >
        {allQuestionsSubmitted ? (
          <img src={StopIcon} alt="End Session" />
        ) : (
          <Pause />
        )}
      </button>
      {tooltipOpen && (
        <div
          className="pause-end-tip"
          ref={tooltipRef}
          style={{
            position: 'absolute',
            backdropFilter: 'blur(20px)',
            WebkitBackdropFilter: 'blur(20px)',
            top: isFooter ? 'auto' : '100%',
            bottom: isFooter ? '100%' : 'auto',
            right: '0',
            marginTop: isFooter ? 'auto' : '.25rem',
            marginBottom: isFooter ? '.25rem' : 'auto',
            backgroundColor: 'var(--surface-modal-glass-light)',
            border: '0',
            padding: '.25rem',
            borderRadius: '.5rem',
            width: 'fit-content',
            zIndex: 1000,
          }}
        >
          <button
            className="button button--glass"
            onClick={() => {
              setConfirmEndIsOpen(true);
              hapticsImpactLight();
              closeSnackbar();
              setTooltipOpen(false);
            }}
          >
            <img src={StopIcon} alt="End Session" />
            <div>Submit Block</div>
          </button>
          {studyPhase === StudyPhase.BLOCK_STUDY && !isDemo && !isSubmitted && (
            <button
              onClick={pauseBlock}
              className="button button--glass"
              style={{ flexDirection: 'row' }}
            >
              <Pause />
              <div>Pause Block</div>
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default PopoverPauseEndMenu;
